import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Select,
  Row,
  Col,
  Input,
  message,
  Spin,
  Checkbox,
  Switch,
} from "antd";
import { CustomInput } from "./customInput";
import CustomSelector from "./customSelector";
import { customWhite, green } from "../constants/colors";
import TreeSelector from "./treeSelector";
import { baseUrl } from "../utills";
import axios from "axios";
import CustomModal from "./customModal";
import CarInfo from "./carInfo";
import { useCarInfo } from "../context/CarInfoContext";
import AddPhotos from "./addPhotos";
import styled from "styled-components";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import CustomSwitch from "./styledSwitch";
import StyledSwitch from "./styledSwitch";
import { CustomPhoneInput } from "./customPhoneInput";
import { useNavigate } from "react-router-dom";
const { TextArea } = Input;

const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 15px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const CustomForm = ({ setOpenModal, cities, province }) => {
  const token = localStorage.getItem("access_token");
  const login_data = JSON.parse(localStorage.getItem("login_data"));
  // console.log("login_data:", login_data);
  const [loading, setLoading] = useState(false);
  const [loadingImg, setLoadingImg]=useState(false)
  const [carInfo] = useCarInfo();
  // console.log("useCarInfo", carInfo);

  const { Option } = Select;
  const [formLayout, setFormLayout] = useState("vertical");
  const [exteriorColors, setExteriorColors] = useState();
  const [form2] = Form.useForm();
  const [carInfoModal, setCarInfoModal] = useState(false);
  const [imagePaths, setImagePaths] = useState([]);
  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [category, setCarCategory] = useState([]);
  const [engineTypes, setEngineTypes] = useState([]);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [carAssembly, setCarAssembly] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [phoneNumber, setPhoneNumber] = useState("");

  const navigate = useNavigate();

  // const [province, setProvince]=useState([]);
  const onChange = (id) => (e) => {
    if (e.target.checked) {
      setCheckedIds((prev) => [...prev, id]);
    } else {
      setCheckedIds((prev) => prev.filter((checkedId) => checkedId !== id));
    }
  };
  // console.log("checkedIds", checkedIds);

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 14,
          },
        }
      : null;
  const buttonItemLayout =
    formLayout === "horizontal"
      ? {
          wrapperCol: {
            span: 14,
            offset: 4,
          },
        }
      : null;

  const uploadImages = async () => {
    setLoadingImg(true);
    try {
      const formData = new FormData();
     
      images.forEach((file) => {
        formData.append("files", file.originFileObj);
      });
      formData.append("background", "false")
      const res = await axios.post(baseUrl + "upload/", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        console.log("uploadImages res...:", res);
        setImagePaths(res?.data?.file_hs);
        setLoadingImg(false);
      }
    } catch (error) {
      setLoadingImg(false);

      console.error("error....:", error);
    }
  };

  useEffect(() => {
    if (images?.length > 0) {
      const timeoutId = setTimeout(() => {
        uploadImages();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [images]);

  const fetchColors = async () => {
    try {
      const res = await axios.get(baseUrl + "get_car_colors/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const transformedData = res?.data?.data?.map((item) => ({
        value: item.id,
        label: item.color_name,
      }));
      setExteriorColors(transformedData);
    } catch (error) {
      console.error("error:", error);
    }
  };

  const getFeatures = async () => {
    try {
      const res = await axios.get(baseUrl + "features");
      setFeatures(res.data);
    } catch (error) {}
  };

  const fetchCarcategory = async () => {
    try {
      const res = await axios.get(baseUrl + "get_car_category/");
      setCarCategory(
        res.data?.data?.map((data) => ({
          label: data?.category_type,
          value: data?.id,
        }))
      );
    } catch (error) {}
  };

  const fetchEngineTypes = async () => {
    try {
      const res = await axios.get(baseUrl + "engine_type");
      setEngineTypes(
        res.data?.map((data) => ({
          label: data?.engine_type,
          value: data?.id,
        }))
      );
    } catch (error) {}
  };

  const fetchTransmissionTypes = async () => {
    try {
      const res = await axios.get(baseUrl + "transmission_type");
      // console.log("transmission types res:", res?.data);
      setTransmissionTypes(
        res.data?.map((data) => ({
          label: data?.transmission_type,
          value: data?.id,
        }))
      );
    } catch (error) {}
  };

  const fetchCarAssembly = async () => {
    try {
      const res = await axios.get(baseUrl + "car_assembly");
      setCarAssembly(
        res.data?.map((data) => ({
          label: data?.assembly,
          value: data?.id,
        }))
      );
    } catch (error) {}
  };

  useEffect(() => {
    fetchColors();
    getFeatures();
    fetchCarcategory();
    fetchEngineTypes();
    fetchTransmissionTypes();
    fetchCarAssembly();
    // fetchProvince();
  }, []);

  const handleImageUpload = (paths) => {
    setImagePaths(paths);
  };
  console.log("carInfo", carInfo);

  const postCar = async (values) => {
    console.log("images paths",imagePaths);

    const updatedVal = {
      ...values,
      car_maker_id: carInfo?.car_maker_id,
      car_model_id: carInfo?.car_model_id,
      car_version_id: carInfo?.car_version_id,
      user_id: login_data?.user?.user_id,
      mileage_km: Number(values?.mileage_km),
      price: Number(values?.price),
      // mobile_num: Number(values?.mobile_num),
      attachments: imagePaths,
      car_post_features: checkedIds,
      mobile_num: phoneNumber,
    };

   if(updatedVal?.attachments?.length <0){
    alert("plz upload pictures")
   } else {
    try {
      setLoading(true);
      const res = await axios.post(baseUrl + `add_carpost`, updatedVal, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setLoading(false);
        messageApi.open({
          type: "success",
          content: "Form Submitted Successfully",
        });
        setOpenModal(false);
        navigate("/upgrade-ad")
        console.log("post res::::", res);

        // navigate("/upgrade-ad",{
        //   state:{
        //     car_post_id:
        //   }
        // });
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to post",
        });
      }
    } catch (error) {
      setLoading(false);
    }
   }
    // console.log("updatedVal", updatedVal);
  };
  // const updatedEngineTypes=engineTypes?.map((engine)=>)
  // const enginTypes = [
  //   {
  //     label: carInfo?.version?.engine_type,
  //     value: carInfo?.version?.engine_type,
  //   },
  // ];
  const onChangeSwitch = (checked) => {
    console.log(`switch to ${checked}`);
  };
  // const handleChangeCode = (value) => {
  //   console.log("code", value);
  // };
  console.log("carInfo:...",carInfo);
  
  return (
    <>
      {contextHolder}

      <CustomModal
        // title="Car Info"
        removeClose="true"
        openModal={carInfoModal}
        setOpenModal={setCarInfoModal}
      >
        <CarInfo setCarInfoModal={setCarInfoModal} />
      </CustomModal>
      <Spin spinning={loading}>
        <Form
          {...formItemLayout}
          layout={formLayout}
          form={form2}
          name="form2"
          onFinish={postCar}
          initialValues={{
            layout: formLayout,
          }}
        >
          <p className="text-[20px] font-[600] mt-10 mb-5 ms-2">
            Your Car Info
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
            <div style={{ position: "relative" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>City</p>
                }
                name="city_id"
                rules={[{ required: true, message: "Please select a site" }]}
              >
                <CustomSelector options={cities} placeholder="-Select City-" />
              </Form.Item>
            </div>

            <Form.Item
              label={
                <p
                  style={{
                    color: "gray",
                    marginBottom: "0px",
                  }}
                >
                  Car Info
                </p>
              }
              name="car_info"
              rules={[
                {
                  required: carInfo ? false : true,
                  message: "Please enter car info!",
                },
              ]}
            >
              <CustomInput
                value={carInfo}
                onClick={() => setCarInfoModal(true)}
                placeholder={
                  carInfo?.make && carInfo?.model && carInfo?.year
                    ? `${carInfo?.year} ${carInfo?.make} ${carInfo?.model}`
                    : "Make / Model / Version"
                }
              />
            </Form.Item>

            <div style={{ position: "relative" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>
                    Registered In
                  </p>
                }
                name="registered_in"
                rules={[{ required: true, message: "Please select a site" }]}
              >
                <CustomSelector
                  options={province}
                  placeholder="Registered In"
                />
              </Form.Item>
            </div>

            <div style={{ position: "relative" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>
                    Exterior Color
                  </p>
                }
                name="color_id"
                rules={[{ required: true, message: "Please select color!" }]}
              >
                <CustomSelector
                  options={exteriorColors}
                  placeholder="Exterior Color"
                />
              </Form.Item>
            </div>

            <Form.Item
              label={
                <p
                  style={{
                    color: "gray",
                    marginBottom: "0px",
                  }}
                >
                  Mileage (km)
                </p>
              }
              name="mileage_km"
              rules={[{ required: true, message: "Please enter mileage!" }]}
            >
              <CustomInput placeholder="Mileage" />
            </Form.Item>

            <Form.Item
              label={
                <p
                  style={{
                    color: "gray",
                    marginBottom: "0px",
                  }}
                >
                  Price (PKR)
                </p>
              }
              name="price"
              rules={[{ required: true, message: "Please enter price!" }]}
            >
              <CustomInput placeholder="Price" />
            </Form.Item>

            <div style={{ position: "relative" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Category</p>
                }
                name="category_id"
                rules={[{ required: true, message: "Please select color!" }]}
              >
                <CustomSelector
                  options={category}
                  placeholder="Select Category"
                />
              </Form.Item>
            </div>

            <Form.Item
              label={
                <p
                  style={{
                    color: "gray",
                    marginBottom: "0px",
                  }}
                >
                  Ad Description
                </p>
              }
              name="description"
              rules={[{ required: true, message: "Please enter price!" }]}
            >
              <TextArea
                style={{
                  background: "#fbf7fb",
                  color: "gray",
                  fontWeight: 500,
                }}
                rows={4}
                placeholder={`Describe Your car:\nExample: Alloy rim, first owner,\ngenuine parts, maintained by authorized workshop,\nexcellent mileage, original paint, etc.`}
              />
            </Form.Item>
          </div>

          <div className="md:px-[10px] mb-10">
            <p className="text-[20px] font-[600] mb-4">Upload Photos</p>
            <Spin spinning={loadingImg} className="custom-spin">
            <div
              style={{ minWidth: "100%" }}
              className="border border-dashed border-customGreen min-h-[300px] px-4 pt-[130px] pb-4 relative rounded-[8px]"
            >
              <AddPhotos images={images} setImages={setImages} imagePaths={imagePaths} />
            </div>
            </Spin>
          </div>

          {carInfo?.version?.id ? (
            <>
              <p className="text-[20px] font-[600] mt-2 mb-5 ms-2">
                Additional Information
              </p>

              <Row>
                <Col xs={24} md={12} style={{ padding: "10px" }}>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      label={
                        <p style={{ color: "gray", marginBottom: "0px" }}>
                          Engine Type
                        </p>
                      }
                      name="engine_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select engine type!",
                        },
                      ]}
                    >
                      <CustomSelector
                        options={engineTypes}
                        placeholder="Engine Type"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24} md={12} style={{ padding: "10px" }}>
                  <Form.Item
                    label={
                      <p
                        style={{
                          color: "gray",
                          marginBottom: "0px",
                        }}
                      >
                        Engine Capacity (cc)
                      </p>
                    }
                    name="engine_cc"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please enter engine capacity!",
                    //   },
                    // ]}
                  >
                    <CustomInput
                      // defaultValue={carInfo?.version?.engine_cc}
                      value={carInfo?.version?.engine_cc}
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} style={{ padding: "10px" }}>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      label={
                        <p style={{ color: "gray", marginBottom: "0px" }}>
                          Transmission
                        </p>
                      }
                      name="transmission_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select transmission!",
                        },
                      ]}
                    >
                      <CustomSelector
                        options={transmissionTypes}
                        placeholder="Select Transmission Type"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24} md={12} style={{ padding: "10px" }}>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      label={
                        <p style={{ color: "gray", marginBottom: "0px" }}>
                          Assembly
                        </p>
                      }
                      name="car_assem_id"
                      rules={[
                        { required: true, message: "Please select assembly!" },
                      ]}
                    >
                      <CustomSelector
                        options={carAssembly}
                        placeholder="Select Assembly"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  marginTop: "10px",
                  paddingLeft: "10px",
                }}
              >
                Features
              </p>

              <CheckboxContainer>
                {features?.map((data) => (
                  <Checkbox onChange={onChange(data.id)} key={data.id}>
                    {data?.features}
                  </Checkbox>
                ))}
              </CheckboxContainer>
            </>
          ) : null}

          <p className="text-[20px] font-[600] mt-10 mb-5 ms-2">
            Contact Information
          </p>

          <Row>
            {/* <Col xs={24} md={12} xl={12} style={{ padding: "10px" }}>
              <Form.Item
                label={
                  <p
                    style={{
                      color: "gray",
                      marginBottom: "0px",
                    }}
                  >
                    Full Name
                  </p>
                }
              >
                <CustomInput placeholder="Full Name" />
              </Form.Item>
            </Col> */}

            <Col xs={24} md={12} style={{ padding: "10px" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Phone</p>
                }
                name="mobile_num"
                rules={[{ required: true, message: "Please enter contact no" }]}
              >
                {/* <CustomInput placeholder="03XXXXXXXXX" /> */}
                <CustomPhoneInput
                  // onChange={handleChangeCode}
                  placeholder="Enter phone number"
                  setPhoneNumber={setPhoneNumber}
                  phoneNumber={phoneNumber}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <div className="flex gap-2 md:mt-10">
                <MdOutlinePhoneAndroid style={{ fontSize: "50px" }} />
                <p>
                  Enter a genuine 11 digit mobile no. with format 03XXXXXXXXX.
                  All inquires will come on this number.
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="flex justify-between items-center px-2">
                <div className="flex items-center gap-4">
                  <div className="w-[35px] h-[35px] rounded rounded-[100%] bg-[#32b37b] text-white flex justify-center items-center">
                    <FaWhatsapp style={{ fontSize: "24px" }} />
                  </div>
                  <p className="text-[16px]">Allow WhatsApp Contact</p>
                </div>
                <StyledSwitch
                  size="large"
                  defaultChecked
                  onChange={onChangeSwitch}
                />
              </div>
            </Col>
            {/* <Col xs={24} md={12} style={{ padding: "10px" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Email</p>
                }
               
              >
                <CustomInput placeholder="Enter your email address" />
              </Form.Item>
            </Col> */}
            {/* <Col xs={24} md={12} style={{ padding: "10px" }}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Location</p>
                }
              
              >
                <CustomInput placeholder="Enter your address" />
              </Form.Item>
            </Col> */}
          </Row>

          <Form.Item
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "20px",
            }}
            {...buttonItemLayout}
          >
            <Button
              size="large"
              style={{
                backgroundColor: green,
                borderColor: green,
                color: customWhite,
                borderRadius: "5px",
                width: "150px",
                marginLeft: "10px",
                height: "48px",
                fontWeight: 500,
              }}
              type="primary"
              htmlType="submit"
              disabled={loadingImg}
            >
              Submit Now
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </>
  );
};

export default CustomForm;
